import React, { useState, useEffect } from "react";
import {
  Navbar,
  Button,
  Container,
  Row,
  DropdownButton,
  Dropdown,
} from "react-bootstrap";
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { auth } from "../firebaseConfig";
import { signOut, onAuthStateChanged } from "firebase/auth";
import { FaBars, FaUser, FaSignOutAlt, FaBox, FaTags, FaStore } from "react-icons/fa";

const DashboardLayout = () => {
  const [isToggled, setIsToggled] = useState(false);
  const [username, setUsername] = useState("");
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleToggle = () => {
    setIsToggled(!isToggled);
    document.body.classList.toggle("no-scroll", !isToggled);
  };

  const handleResize = () => {
    if (window.innerWidth >= 992) {
      setIsToggled(false);
    } else {
      setIsToggled(true);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setUsername("");
      navigate("/LoginAdmin");
    } catch (error) {
      console.error("Logout Error:", error);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // Any Firebase Auth user is an admin
        setUsername(user.email);
      } else {
        navigate("/LoginAdmin");
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        <div
          className={`d-flex p-0 ${isToggled ? "toggled" : ""}`}
          id="wrapper"
        >
          <div
            className={`border-end ${isToggled ? "show-sidebar" : ""}`}
            id="sidebar-wrapper"
          >
            <div className="sidebar-heading text-center d-flex align-items-center justify-content-center gap-2">
              <FaStore size={22} /> Kamdhenu Admin
            </div>
            <div className="list-group list-group-flush mt-3 px-2">
              <Link
                to="/Dashboard/AddProducts"
                className={`list-group-item list-group-item-action ${pathname === "/Dashboard/AddProducts" ? "active" : ""}`}
              >
                <FaBox /> Products
              </Link>

              <Link
                to="/Dashboard/CategoriesItemsAdmin"
                className={`list-group-item list-group-item-action ${pathname === "/Dashboard/CategoriesItemsAdmin" ? "active" : ""}`}
              >
                <FaTags /> Categories
              </Link>
            </div>
          </div>

          {/* Overlay */}
          {isToggled && <div className="overlay" onClick={handleToggle}></div>}

          <div id="page-content-wrapper">
            <Navbar className="navbar navbar-expand-lg border-bottom shadow-sm">
              <div className="container-fluid">
                <Button
                  variant="light"
                  className="ms-0 shadow-none d-flex align-items-center justify-content-center p-0"
                  id="sidebarToggle"
                  onClick={handleToggle}
                  style={{ width: "40px", height: "40px", border: "1px solid #E5E7EB", backgroundColor: "#fff", borderRadius: "8px" }}
                >
                  <FaBars size={18} style={{ color: "#111827", fill: "#111827" }} />
                </Button>

                <div className="ms-auto d-flex align-items-center">
                  <DropdownButton
                    align="end"
                    title={
                      <span className="d-flex align-items-center gap-2">
                        <FaUser size={14} color="#111827" /> <span className="d-none d-md-inline fw-bold text-dark">Admin</span>
                      </span>
                    }
                    id="dropdown-menu-align-end"
                    className="profile_icn"
                    variant="light"
                  >
                    <Dropdown.Header>Signed in as</Dropdown.Header>
                    <Dropdown.ItemText className="fw-bold mb-2">{username}</Dropdown.ItemText>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={handleLogout} className="d-flex align-items-center gap-2 text-danger">
                      <FaSignOutAlt /> Logout
                    </Dropdown.Item>
                  </DropdownButton>
                </div>
              </div>
            </Navbar>
            <div className="container-fluid mt-4 pb-5 px-md-4">
              <Outlet />
            </div>
          </div>
        </div>
      </Row>
    </Container>
  );
};

export default DashboardLayout;
